import { render, staticRenderFns } from "./TrackSelectCompilationsGenre.vue?vue&type=template&id=2372cad5&"
import script from "./TrackSelectCompilationsGenre.vue?vue&type=script&lang=ts&"
export * from "./TrackSelectCompilationsGenre.vue?vue&type=script&lang=ts&"
import style0 from "./TrackSelectCompilationsGenre.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports